import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const config = {
  apiKey: "AIzaSyBAHWCLdYkzInT4s0BpSjUgMy-JZOBwrNA",
  authDomain: "idea-boards.firebaseapp.com",
  projectId: "idea-boards",
  storageBucket: "idea-boards.appspot.com",
  messagingSenderId: "127035041498",
  appId: "1:127035041498:web:37be0e2b5d8951b0cbe7e3",
  measurementId: "G-T3L80PRTGL",
};

firebase.initializeApp(config);

export const boardsCollection = firebase.firestore().collection("/boards");
export const errorsCollection = firebase.firestore().collection("/errors");
export const summaryRequestsCollection = firebase.firestore().collection("/summaryRequests");
export default firebase;
